export var GroupAppKey;
(function (GroupAppKey) {
    GroupAppKey["MEMBERS_APP"] = "MEMBERS_APP";
    GroupAppKey["FEED_APP"] = "FEED_APP";
    GroupAppKey["ABOUT_APP"] = "ABOUT_APP";
    GroupAppKey["GALLERY_APP"] = "GALLERY_APP";
    GroupAppKey["EVENTS_APP"] = "EVENTS_APP";
    GroupAppKey["CUSTOM_APP"] = "CUSTOM_APP";
    GroupAppKey["FILES_APP"] = "FILES_APP";
    GroupAppKey["CUSTOM_APP_2"] = "CUSTOM_APP_2";
    GroupAppKey["CUSTOM_APP_3"] = "CUSTOM_APP_3";
})(GroupAppKey || (GroupAppKey = {}));
export var ContentType;
(function (ContentType) {
    ContentType["PLAIN_TEXT"] = "PLAIN_TEXT";
    ContentType["DRAFTJS"] = "DRAFTJS";
    ContentType["RICH_CONTENT"] = "RICH_CONTENT";
})(ContentType || (ContentType = {}));
//# sourceMappingURL=types.impl.js.map